<template>
  <div>
    <a class="block block-link-pop text-right block-mode-loading-refresh" href="javascript:void(0)" :class="{'block-mode-loading': isProcessing}">
      <div class="block-content block-content-full clearfix">
          <div class="float-left mt-10 d-none d-sm-block">
            <i ><font-awesome-icon icon="phone-volume" class="fa-3x text-body-bg-dark" /></i>
          </div>
          <div class="font-size-h3 font-w600" data-toggle="countTo" data-speed="1000" data-to="1500">
            {{calls_count.calldebtor + calls_count.callContactface}}
          </div>
          <div class="font-size-sm font-w600 text-uppercase text-muted">Звонков</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      calls_count: [],
      isProcessing: false,
    };
  },
  mounted() {
    this.getCallsCount();
  },
  methods: {
    getCallsCount() {
      this.isProcessing = true;
      axios.get('/admin/stats/calls/count')
        .then((res) => {
          this.calls_count = res.data.calls_count;
          this.isProcessing = false;
        });
    },
  },
};
</script>
